<template>
	<div id="data-view">
		<dv-full-screen-container>
			<transition name="fade">
				<dv-border-box-6 v-if="login">
					<div class="head">
						<data-head></data-head>
					</div>
					<!-- <div class="top">
						<div class="subTitle">
							2020-05-23 星期五 13:45:50
						</div>
						<div class="title">德育数据大屏</div>
						<div class="subTitle">温州市瓯海区</div>
					</div> -->
					<div class="main-content">
						<div class="block1Left">
							<div class="block2Top">
								<div class="block4Left">
									<div class="block5Top">
										<data-v1></data-v1>
									</div>
									<div class="block5Bottom">
										<data-v2></data-v2>
									</div>
								</div>
								<div class="block4Right">
									<div class="block6Top">
										<data-v3></data-v3>
									</div>
									<div class="block6Middle">
										<data-v4></data-v4>
									</div>
									<div class="block6Bottom">
										<data-v5></data-v5>
									</div>
								</div>
							</div>
						</div>
						<div class="block2Right">
							<div class="block3Top">
								<data-v6></data-v6>
							</div>
							<div class="block3Bottom">
								<data-v7></data-v7>
							</div>
						</div>
					</div>
				</dv-border-box-6>
			</transition>
			<transition name="fade">
				<div class="loginPage" v-if="!login">
					<div class="loading">
						<div class="logo">
							<el-image class="elImg" src="/static/loading.gif" fit="cover" />
						</div>
						<div class="tips">已打开密码保护，请输入密码</div>
						<div class="login">
							<div>
								<input type="password" v-model="password" placeholder="请输入密码" />
							</div>
							<div>
								<button @click="setLogin">确定</button>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</dv-full-screen-container>
	</div>
</template>

<script>
	import dataHead from '@/components/head.vue'
	import dataV1 from '@/components/dataV1.vue'
	import dataV2 from '@/components/dataV2.vue'
	import dataV3 from '@/components/dataV3.vue'
	import dataV4 from '@/components/dataV4.vue'
	import dataV5 from '@/components/dataV5.vue'
	import dataV6 from '@/components/dataV6.vue'
	import dataV7 from '@/components/dataV7.vue'
	
	import countTo from 'vue-count-to'
	
	import ElImage from '@/components/ElImage/src/main'
	
	import {
		mapGetters
	} from 'vuex'
	
	export default {
		name: 'DataView',
		components: {
			dataV1,
			dataV2,
			dataV3,
			dataV4,
			dataV5,
			dataV6,
			dataV7,
			countTo,
			ElImage,
			dataHead
		},
		data() {
			return {
				password: ''
			}
		},
		computed: {
			...mapGetters([
				'login'
			])
		},
		methods: {
			setLogin() {
				if(this.password.trim()==='Lxp@163.com') {
					this.$store.dispatch('SetLogin', true)
				} else {
					alert("密码错误")
				}
			}
		}
	}
</script>

<style lang="less">
	#data-view {
		width: 100%;
		height: 100%;
		color: #fff;

		#dv-full-screen-container {
			// background-image: url('./img/bgSVG.svg');
		}
		
		.loginPage {
			width: 100%;
			height: 100%;
			background-color: rgb(13, 42, 66);
			display: flex;
			justify-content: center;
			align-items: center;
			.loading {
				height: 300px;
				width: 500px;
				text-align: center;
				.logo {
					width: 100%;
					// padding: 32px 0;
					padding-bottom: 40px;
					.elImg {
						width: 100%;
						img {
							width: 100px;
						}
					}
				}
				.tips {
					font-size: 18px;
					margin-bottom: 20px;
				}
				.login {
					display: flex;
					align-items: center;
					justify-content: center;
					input {
						height: 34px;
						padding: 0px 12px;
						font-size: 16px;
						line-height: 1.42857143;
						color: #555;
						background-color: #fff;
						border: 1px solid #ccc;
						border-radius: 4px;
						-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
						box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
						-webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
						-o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
						transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
						width: 220px;
						margin-right: 12px;
					}
					button {
						color: #FFFFFF;
						background-color: #428bca;
						border-color: #357ebd;
						padding: 0px 22px;
						font-size: 16px;
						line-height: 34px;
						border: 1px solid #0000 0;
						border-radius: 6px;
						cursor: pointer;
					}
				}
			}
		}
		
		.head {
			// height: 60px;
			height: 80px;
		}

		.main-content {
			padding: 0 10px;
			width: calc(100% - 20px);
			height: calc(100% - 80px);
			display: flex;
			// flex-direction: row;
			.block1Left {
				flex: 0 0 70%;
				height: 100%;
				.block2Top {
					height: 100%;
					display: flex;
					.block4Left {
						flex: 0 0 50%;
						.block5Top {
							height: 60%;
						}
						.block5Bottom {
							height: 40%;
						}
					}
					.block4Right {
						flex: 0 0 50%;
						.block6Top {
							height: 20%;
						}
						.block6Middle {
							height: 40%;
						}
						.block6Bottom {
							height: 40%;
						}
					}
				}
				.block2Bottom {
					height: 30%;
				}
			}
			.block2Right {
				flex: 0 0 30%;
				height: 100%;
				.block3Top {
					height: 55%;
				}
				.block3Bottom {
					height: 45%;
				}
			}
		}
	}
	.fade-enter-active, .fade-leave-active {
	  transition: opacity 1.5s ease;
	}
	.fade-enter, .fade-leave-to {
	  opacity: 0;
	}
</style>
